const MOBILE_BREAKPOINT = 768;

const getErrorFields = (errors, parent = '') => Object.entries(errors || {}).flatMap(([field, value]) => {
  const fieldPath = parent ? `${parent}.${field}` : field;
  if (value && typeof value === 'object') {
    return getErrorFields(value, fieldPath);
  }
  return value ? [fieldPath] : [];
});

const isVisible = element => {
  let current = element;
  while (current && current.nodeType === 1) {
    const style = window.getComputedStyle(current);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    current = current.parentElement;
  }
  return true;
};

const toKebabCase = field => field.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);

const findFieldElement = field => Array.from(
  document.querySelectorAll('[data-validation-field], [data-testid], [id], [name]'),
).find(element => {
  const validationFields = (element.getAttribute('data-validation-field') || '').split(/\s+/);
  const testId = element.getAttribute('data-testid');
  return element.id === field || element.name === field
    || validationFields.includes(field) || testId === field || testId === toKebabCase(field);
});

const getScrollTarget = element => {
  if (!element) {
    return undefined;
  }
  if (element.matches('input[type="checkbox"], input[type="radio"]')) {
    return element.closest('label') || element;
  }
  return element;
};

export const scrollToFirstError = errors => {
  if (window.innerWidth >= MOBILE_BREAKPOINT || getErrorFields(errors).length === 0) {
    return;
  }

  const schedule = typeof window.requestAnimationFrame === 'function'
    ? callback => window.requestAnimationFrame(callback)
    : callback => window.setTimeout(callback, 0);
  schedule(() => {
    const matchingField = getErrorFields(errors)
      .map(findFieldElement)
      .find(element => element && isVisible(element));
    const invalidControl = Array.from(document.querySelectorAll('[aria-invalid="true"]'))
      .find(isVisible);
    const errorMessage = Array.from(document.querySelectorAll('[role="alert"], .Mui-error'))
      .find(isVisible);
    const target = getScrollTarget(matchingField || invalidControl || errorMessage);

    target?.scrollIntoView({behavior: 'smooth', block: 'center'});
  });
};
